import { render, staticRenderFns } from "./RealIntentionPreviewSp.vue?vue&type=template&id=0c0a0d20&scoped=true"
import script from "./RealIntentionPreviewSp.vue?vue&type=script&lang=js"
export * from "./RealIntentionPreviewSp.vue?vue&type=script&lang=js"
import style0 from "./RealIntentionPreviewSp.vue?vue&type=style&index=0&id=0c0a0d20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a0d20",
  null
  
)

export default component.exports